<div class="p-card w-full p-1 relative">
  <div class="flex justify-content-between align-items-center px-2 py-1">
    <div class="m-0 text-base gap-2 flex align-items-center">
      @for (item of designators; track index; let index = $index) {
        <div>
          <span
            ><strong class="text-sm">{{ item.designator }}</strong></span
          >
          <p-badge [value]="item.count" />
        </div>
      }
    </div>
    <div class="legend">
      <div class="flex items-center gap-2">
        <div class="legend">
          <ul class="list-none m-0 p-0 flex items-center gap-2">
            <li *ngFor="let key of getLegendKeys()" class="flex align-items-center gap-1">
              <label class="graph-checkbox">
                <input
                  type="checkbox"
                  [checked]="selectedResponsibleUnits[key]"
                  (change)="onCheckboxChange(key, $event)"
                />
                <span
                  class="checkbox-graph"
                  [ngStyle]="{ 'background-color': legendData[key].color, 'border-color': legendData[key].borderColor }"
                >
                </span>
              </label>
              <span
                class="legend-label text-xs cursor-pointer"
                (click)="op.toggle($event)"
                tabindex="0"
                (keyup.enter)="op.toggle($event)"
                [ngClass]="{ 'text-red-500': legendData[key].overlap.length }"
                >{{ legendData[key].label }}</span
              >
              <p-overlayPanel #op [styleClass]="'p-1'" [baseZIndex]="2000" (onShow)="onOverlayShow(op)">
                @if (legendData[key].overlap.length) {
                  @for (overlap of legendData[key].overlap; track index; let index = $index) {
                    <div class="flex align-items-center gap-1 text-xs border-bottom-1 py-1">
                      <strong>{{ overlap.label }}</strong> - {{ overlap.overlapHeight }} {{ overlap.overlapTime }}
                    </div>
                  }
                } @else {
                  <div class="text-xs">{{ 'aup.graph.noOverlap' | translate }}</div>
                }
              </p-overlayPanel>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div id="tooltip"></div>
  <div class="h-12rem">
    <canvas id="chartCanvas" width="100%" height="100%"></canvas>
  </div>
</div>
